<template>
  <div :class="wrapperClasses" v-bind="wrapperAttrs">
    <slot name="title">
      <p v-if="title" :class="titleClasses" v-bind="titleAttrs">{{ title }}</p>
    </slot>
    <div class="w-full"><slot /></div>
  </div>
</template>

<script lang="ts" setup>
import { twMerge } from 'tailwind-merge'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{
  title?: null | string
  titleAttrs?: Record<string, any>
  wrapperAttrs?: Record<string, any>
}>()

const wrapperClasses = computed(() =>
  twMerge(
    'flex flex-col items-start sm:pt-8 pt-6 pt-12',
    props.wrapperAttrs?.class,
    useAttrs().class as string,
  ),
)

const titleClasses = computed(() =>
  twMerge(
    'font-medium text-xl w-full mb-4 sm:mb-6 -mt-[5px] font-black sm:text-2xl text-xl w-full sm:mb-4 sm:pr-12 sm:text-start sm:pr-0',
    props.titleAttrs?.class,
  ),
)
</script>

<style lang=""></style>
